let loadScript = require('./loadScript');
let Captcha = require('./captcha');

module.exports = async function() {
  let submitButtons = document.querySelectorAll('[data-captcha-submit]');
  if (!submitButtons.length) return;

  for(let button of submitButtons) {
    button.disabled = true;
  }

  await loadScript();

  for(let button of submitButtons) {
    let form = button.form;
    
    let captcha = new Captcha(form);
    
    form.onsubmit = async (event) => {
      event.preventDefault();
      await captcha.validateForm(form);
              
      if (form.checkValidity()) {
        form.submit();
      } else {
        form.reportValidity();
      }
    }

    button.disabled = false;
  }

}